import { Reveal, Overline } from "./Reveal";

// Convênios formais informados pela empresa (Banrisul, Banco do Brasil, Caixa, Sicredi, Cresol e Bradesco).
const BANCOS = [
  { name: "Banrisul", logo: "/bancos/banrisul.png", w: 960, h: 181, imgH: "max-h-10" },
  { name: "Banco do Brasil", logo: "/bancos/bb.png", w: 960, h: 135, imgH: "max-h-10" },
  { name: "Caixa", logo: "/bancos/caixa.png", w: 1094, h: 334, imgH: "max-h-10" },
  { name: "Sicredi", logo: "/bancos/sicredi.png", w: 960, h: 227, imgH: "max-h-10" },
  { name: "Cresol", logo: "/bancos/cresol.png", w: 920, h: 183, imgH: "max-h-10" },
  { name: "Bradesco", logo: "/bancos/bradesco.png", w: 960, h: 181, imgH: "max-h-10" },
];

export const Banks = () => (
  <section data-testid="convenios-section" className="mx-auto max-w-[1400px] px-5 py-8 sm:px-8 md:py-20">
    <Reveal><Overline>Convênios formais</Overline></Reveal>
    <Reveal delay={0.1}>
      <h2 className="mt-4 max-w-3xl font-serif text-3xl leading-[1.08] tracking-tight text-[#1A2218] sm:text-4xl lg:text-5xl">
        Convênio formal com as principais <em className="text-[#5D995E]">instituições financeiras.</em>
      </h2>
      <p className="mt-4 max-w-2xl text-sm leading-relaxed text-[#4A5549] sm:text-base">
        A Melo Agro Engenharia possui convênio formal com as instituições abaixo — os projetos e laudos seguem
        os padrões que cada banco exige. A análise e a liberação do crédito são sempre da instituição financeira.
      </p>
    </Reveal>
    <Reveal delay={0.15}>
      <div data-testid="convenios-grid" className="mt-8 flex snap-x snap-mandatory gap-3 overflow-x-auto pb-2 sm:grid sm:grid-cols-3 sm:overflow-visible sm:pb-0 lg:grid-cols-6">
        {BANCOS.map((b) => (
          <div
            key={b.name}
            data-testid={`convenio-${b.name.toLowerCase().replace(/\s+/g, "-")}`}
            className="flex h-[76px] w-[190px] shrink-0 snap-start items-center justify-center rounded-[18px] border border-[#E5E0D5] bg-white px-5 transition-[border-color,transform,box-shadow] duration-300 hover:-translate-y-1 hover:border-[#5D995E] hover:shadow-[0_18px_40px_-24px_rgba(35,61,37,0.35)] sm:w-auto"
          >
            <img src={b.logo} alt={`Logotipo do ${b.name}`} width={b.w} height={b.h} loading="lazy" className={`${b.imgH} w-auto max-w-full object-contain`} />
          </div>
        ))}
      </div>
    </Reveal>
  </section>
);
